export default "__VITE_ASSET__AwQSjje9__"